import EditarContaCartaoModal from './EditarContaCartaoModal';

export default EditarContaCartaoModal;
